<template>
  <v-container class="sign-in" fluid fill-height>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="2" md="6" offset-md="3" xl="4" offset-xl="4" align="center">

        <v-layout row v-if="error">
          <v-flex xs12 sm8 offset-sm2>
            <v-card class="elevation-8">
              <app-alert-error @dismissed="onDismiss" :text="error.message"></app-alert-error>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row >
          <v-flex xs10 offset-xs1 sm8 offset-sm2>
            <v-card class="mt-1 elevation-8">
              <v-card-text class="ma-0 pt-0 px-3">
                <v-row class="primary">
                  <v-col cols="12" class="pb-0">
                    <a @click="goToPath('/')">
                      <v-img height="auto" width="80" src="@/assets/zf-logo-white-cirle.png"/>
                    </a>
                  </v-col>
                </v-row>
                <v-row class="text-center primary white--text mt-0">
                  <v-col cols="12">
                  <h2>Login to your account</h2>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <v-form lazy-validation v-model="valid" ref="form" @submit.prevent="onSignin">
                    <v-layout row>
                      <v-flex xs12>
                        <v-text-field color="farmer_green" prepend-icon="person" name="email" label="E-mail" :rules="fieldRules('E-mail', 50)" type="email" v-model="email" required></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs12>
                        <v-text-field color="farmer_green" prepend-icon="lock" :append-icon="show ? 'visibility_off' : 'visibility'" name="password" label="Password" :rules="fieldRules('Password', 20)" :type="show ? 'text' : 'password'" v-model="password" @click:append="show = !show" required></v-text-field>
                        <v-card-actions>
                        <v-spacer></v-spacer><a color="farmer_green" dark outline @click="goToPath('/reset-password')" class="mr-5">Forgot Password?</a>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>

                    <v-row>
                      <v-col>
                        <v-btn block color="farmer_green" type="submit"  :disabled="isLoading" :loading="isLoading"  class="my-1 white--text">Login</v-btn>

                        <div class="hr-sect">or</div>

                        <v-btn block color="red" class="mt-2 white--text" @click.prevent="onSignInWithGoogle" :disabled="isGLoading" :loading="isGLoading">
                          <v-icon left dark>fa-google-plus</v-icon>Login with Google
                        </v-btn>

                        <v-btn block color="farmer_green" class="mt-2 white--text" to="/sign-up">Sign up</v-btn>
                      </v-col>
                    </v-row>
                    <v-layout row>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    isLoading: false,
    isGLoading: false,
    isFLoading: false,
    valid: true,
    show: '',
    email: '',
    password: ''
  }),
  watch: {
    // user(value) {
    //   if (value !== null && value !== undefined) {
    //     router.push('/')
    //   }
    // }
  },

  computed: {
    ...mapGetters(['error', 'loading']),
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    }
  },

  methods: {
    onSignin() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        const credentials = { email: this.email, password: this.password }
        store.dispatch('signUserIn', credentials)
          .then(() => {
            this.isLoading = false
          })
          .catch(err => {
            this.isLoading = false
            store.commit('setError', err)
          })
      }
    },

    onSignInWithGoogle() {
      this.isGLoading = true
      store.dispatch('signUserInWithGoogle')
        .then(() => {
          this.isGLoading = false
        }).catch(() => {
          this.isGLoading = false
        })
    }
  },

  mounted() {
    store.commit('clearError')
  }
}
</script>

<style scoped>
.sign-in {
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6)),
    url('../../assets/about/mission.jpg');
  background-repeat: repeat;
}
.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin: 8px 0px;
}
.hr-sect::before,
.hr-sect::after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.35);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 8px;
}
</style>
